<template>
  <video
    class="video-preview"
    ref="video"
    muted
    autoplay>
  </video>
</template>

<script>
export default {
  props: {
    deviceId: {
      type: String
    }
  },

  watch: {
    deviceId(v) {
      if (v) {
        this.setupWebCamPreview(v);
      }
    }
  },

  beforeDestroy() {
    this.stop();
  },

  methods: {
    async setupWebCamPreview() {
      try {
        let videoStream = await navigator.mediaDevices.getUserMedia({video: {
          deviceId: {exact: this.deviceId}
        }});
        this.$refs.video.srcObject = videoStream;
        this._videoStream = videoStream;
      } catch (e) {
        log.error('failed to setup WebCam preview', e);
      }
    },

    stop() {
      if (this._videoStream) {
        this._videoStream.getTracks().forEach(track => track.stop());
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.video-preview {
  background-color: $secondary-color;
  border: 2px solid rgba(0,0,0,0.7);
  border-radius: 5px;
  width: 100%;
  height: 100%;
}
</style>
